module.exports = __webpack_public_path__ + "images/emoji/expressionless.ab8ee191f4eabbc60879.png";